// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__2RA5x","open":"MenuToggle_open__1GajG"};